import { 
  Button,
  Box, Typography, Paper
} from "@mui/material";
import { Google } from "@mui/icons-material";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../contants/Auth";

function LoginModal() {
  const handleLogin = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (err) {
      console.error("로그인 실패", err);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper elevation={3} sx={{ p: 6, width: 360, textAlign: "center" }}>
        <Box sx={{ mb: 4 }}>
          <img
            src="/logo/logisvalley-logo.png"
            alt="회사 로고"
            style={{ height: 48, objectFit: "contain", margin: "0 auto"}}
          />
        </Box>
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 4 }}>
          Marketpulse 구글 계정으로 로그인해 주세요
        </Typography>
        <Button
          variant="contained"
          startIcon={<Google />}
          fullWidth
          onClick={handleLogin}
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          Google 계정으로 로그인
        </Button>
      </Paper>
    </Box>
  );
}

export default LoginModal;